module.exports = __webpack_public_path__ + "media/images/components/sub-header-bg-0cacec90421132e7f368ed513c153dbd.jpg";